<div class="fid-panel" *ngIf="row">
  <section class="fid-card">
    <div class="fid-card__header">
      <span class="fid-card__title" [title]="row.investmentDescription"><mat-icon>trending_up</mat-icon> {{ row.investmentDescription || 'Inversión financiera' }}</span>
      <app-status-pill [label]="statusLabel" [variant]="statusVariant"></app-status-pill>
    </div>

    <div class="fid-progress">
      <div class="fid-progress__bar">
        <div class="fid-progress__fill" [style.width.%]="percent"></div>
      </div>
      <div class="fid-progress__legend">
        <span>Pagado <strong>{{ row.paidAmount | number:'1.2-2' }} €</strong></span>
        <span>Pendiente <strong>{{ row.pendingAmount | number:'1.2-2' }} €</strong></span>
        <span>Inversión <strong>{{ row.investmentValue | number:'1.2-2' }} €</strong></span>
      </div>
    </div>

    <div class="fid-kpis">
      <div class="fid-kpi fid-kpi--accent">
        <span class="fid-kpi__label">Valor neto contable</span>
        <span class="fid-kpi__value">{{ (row.netBookValue || 0) | number:'1.2-2' }} €</span>
      </div>
      <div class="fid-kpi">
        <span class="fid-kpi__label">Rentabilidad / interés</span>
        <span class="fid-kpi__value">{{ (row.percentageOfProfitabilityOrInterest || 0) | number:'1.2-2' }} %</span>
      </div>
      <div class="fid-kpi">
        <span class="fid-kpi__label">Participaciones</span>
        <span class="fid-kpi__value">{{ (row.numberOfUnitsOrSharesInvested || 0) | number:'1.0-2' }}</span>
      </div>
      <div class="fid-kpi">
        <span class="fid-kpi__label">Plazo</span>
        <span class="fid-kpi__value">{{ row.termInMonths ? row.termInMonths + ' meses' : '—' }}</span>
      </div>
      <div class="fid-kpi">
        <span class="fid-kpi__label">Fecha inversión</span>
        <span class="fid-kpi__value">{{ row.investmentDate ? (row.investmentDate | date:'dd/MM/yyyy') : '—' }}</span>
      </div>
      <div class="fid-kpi">
        <span class="fid-kpi__label">Último balance</span>
        <span class="fid-kpi__value">{{ row.lastBalanceSheetDate ? (row.lastBalanceSheetDate | date:'dd/MM/yyyy') : '—' }}</span>
      </div>
    </div>

    <div class="fid-lines">
      <div class="fid-line">
        <span class="fid-line__label">Cuenta contable</span>
        <span class="fid-line__value" [title]="accountLabel">{{ accountLabel }}</span>
      </div>
      <div class="fid-line">
        <span class="fid-line__label">Genera rendimientos</span>
        <span class="fid-line__value">{{ row.generatesReturns ? 'Sí' : 'No' }}</span>
      </div>
      <div class="fid-line">
        <span class="fid-line__label">Documento adjunto</span>
        <span class="fid-line__value">{{ row.isPdf ? 'PDF' : (row.isImage ? 'Imagen' : '—') }}</span>
      </div>
    </div>

    <div class="fid-actions">
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="edit.emit()">
        <mat-icon>edit</mat-icon> Editar inversión
      </button>
    </div>
  </section>

  <section class="fid-card">
    <div class="fid-card__header">
      <span class="fid-card__title"><mat-icon>date_range</mat-icon> Operaciones de la inversión</span>
    </div>

    <app-loading-state *ngIf="loading" [compact]="true" message="Cargando pagos…"></app-loading-state>

    <div class="fid-empty fid-empty--error" *ngIf="!loading && error">
      <mat-icon>error</mat-icon>
      <span>No se pudieron cargar los pagos de la inversión.</span>
      <button mat-stroked-button class="cf-btn" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <div class="fid-block" *ngIf="!loading && !error">
      <div class="fid-block__header">
        <span class="fid-block__title"><mat-icon>payment</mat-icon> Pagos</span>
        <span class="fid-block__side">
          <span class="fid-block__summary" *ngIf="count > 0">
            {{ count }} · <strong>{{ paidTotal | number:'1.2-2' }} €</strong>
            <ng-container *ngIf="commissionsTotal"> · Comisiones {{ commissionsTotal | number:'1.2-2' }} €</ng-container>
          </span>
          <button mat-stroked-button type="button" class="cf-btn cf-btn--primary fid-add" (click)="add()">
            <mat-icon>add</mat-icon> Añadir
          </button>
        </span>
      </div>

      <div class="fid-moves" *ngIf="lines.length">
        <div class="fid-move" *ngFor="let line of lines; trackBy: trackByUid">
          <span class="fid-move__date">{{ line.date | date:'dd/MM/yyyy' }}</span>
          <span class="fid-move__info">
            <span class="fid-move__concept" [title]="line.concept">{{ line.concept }}</span>
            <span class="fid-move__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
          </span>
          <span class="fid-move__amount">{{ line.amount | number:'1.2-2' }} €</span>
          <span class="fid-move__actions">
            <button type="button" class="fid-icon-btn" (click)="editLine(line)" title="Editar" aria-label="Editar pago">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" class="fid-icon-btn fid-icon-btn--danger" (click)="deleteLine(line)" title="Eliminar" aria-label="Eliminar pago">
              <mat-icon>delete</mat-icon>
            </button>
          </span>
        </div>
        <button type="button" class="fid-more" *ngIf="count > maxLines" (click)="manage()">
          Ver los {{ count }} pagos <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <div class="fid-block__empty" *ngIf="!lines.length">Sin pagos registrados</div>
    </div>
  </section>
</div>
